export default {
    'lang': 'zh-cn',
    'placeholder': '请选择',
    'zh-cn': {
        'placeholder': '请选择'
    },
    'en-us': {
        'placeholder': 'Please select'
    },
    'zh-tw': {
        'placeholder': '請選擇'
    },
    'vi-vn': {
        'placeholder': 'Hãy chọn'
    },
}
